<template>
    <el-dialog
            :visible.sync="addNumDialogVisible"
            width="50%"
            center>
        <div class="title flex aic jcc pb30">是否确定为该患者加号？</div>
        <div class="flex aic pb30 pt30 pl50">1.如复诊患者，直接加号;</div>
        <div class="flex aic pl50">2.如初诊患者，先在线建档，再加号。</div>
        <span slot="footer" class="dialog-footer flex aic jcc pb20 pt20">
        <div class="btton flex aic jcc pointer" @click="addNumDialogVisible = false">取 消</div>
        <div class="btton flex aic jcc ml40 pointer" @click="addNum">加 号</div>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "addNum-dialog",
        data(){
            return {
                addNumDialogVisible:false
            }
        },
        methods:{
            showDialog(){
                this.addNumDialogVisible = true;
            },
            hideDialog(){
                this.addNumDialogVisible = false;
            },
            addNum(){
                this.$emit('addNum');
            }
        }
    }
</script>

<style lang="scss" scoped>
.title{
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #333333;
    border-bottom: 1px solid #E8E8E8;
}
    .btton{
        width: 137px;
        height: 36px;
        border: 1px solid #3692F9;
        border-radius: 4px;
        &:nth-child(1){
            color: #3692F9;
        }
        &:nth-child(2){
            background: #3692F9;
            color: #ffffff;
        }
    }
</style>